<!--과정 그룹 버튼-->
<template>
  <div class="wrap_button">
    <ul>
      <li v-for="button in getButtons" :key="button.id">
        <ComCorsButton
          :id="button.id"
          :label="button.label"
          :button-class="button.buttonClass"
          :is-disabled="button.isDisabled"
          :tooltip="button.tooltip"
          @click="handleButtonClick(button)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import {isEmpty} from 'lodash'
import ComCorsButton from '~pages/nrw/common/ComCorsButton'
export default {
  name: 'ComCorsButtonGroup',
  // metaInfo () {
  //   return {
  //     title: '멀티캠퍼스 :: 검색결과'
  //   }
  // },
  components: {
    ComCorsButton
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    listType: {
      type: String,
      default: 'list'
    }
  },
  data () {
    return {
      sysDate: new Date()
    }
  },
  computed: {
    isMobile () {
      return !window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    promoInfoStore () {
      return window.vue.getStore('promoInfo')
    },
    promoInfo () {
      return this.promoInfoStore.state.promoInfo
    },
    btnCtrl () {
      if (this.item.validYn === 'N') {
        return 'DISABLE'
      }

      if (this.item.eduPsbYn === 'Y') {
        return 'LEARN'
      }

      if (this.item.aplPsbYn === 'Y') {
        if (this.item.otsYn === 'Y') {
          return 'LIC'
        }
        return 'APL'
      }
      return 'DISABLE'
    },

    getButtons () {
      if (!this.item) return

      const buttons = []

      // 맛보기 버튼
      if (this.listType === 'list' && this.showPreViewTopButton()) {
        buttons.push({
          id: 'btnPreViewTop',
          label: this.item.proMovYn === 'Y' ? '홍보영상' : '맛보기',
          buttonClass: '',
          isDisabled: false
        })
      }

      // 과정세부정보 버튼
      if (this.listType === 'list' && this.showDetailTopButton()) {
        buttons.push({
          id: 'btnDetailTop',
          label: '과정세부정보',
          buttonClass: '',
          isDisabled: false
        })
      }

      // 수강신청 및 오픈예정 버튼
      if (this.showOpenOrApplyButtons()) {
        const { id, label, isDisabled, tooltip } = this.getOpenOrApplyButtonConfig(this.item)
        if (label) {
          buttons.push({
            id,
            label,
            buttonClass: !isDisabled ? 'accent' : '',
            isDisabled,
            tooltip
          })
        }
      }

      // 학습하기 버튼
      if (this.showImmediateLearnOrApplyButtons()) {
        const { id, label, isDisabled, tooltip } = this.getImmediateLearnOrApplyButtonConfig(this.item)
        if (label) {
          buttons.push({
            id,
            label,
            buttonClass: !isDisabled ? 'accent' : '',
            isDisabled,
            tooltip
          })
        }
      }
      // console.log('과정 buttons : ', buttons)
      return buttons
    }
  },
  methods: {
    handleButtonClick (button) {
      console.log(`${button.label} 버튼이 클릭되었습니다.`, this.item)
      switch (button.id) {
        case 'btnPreViewTop':
        case 'btnDetailTop':
          this.previewCourse(this.item)
          break
        case 'btnNextTop':
          this.order()
          break
        case 'btnLearnTop':
          this.startLearning(this.item)
          break
        case 'btnImdtlLrnTop':
          this.order()
          // this.immediateLearning(this.item)
          break
        default:
          console.log('알 수 없는 버튼 ID:', button.id)
      }
    },
    showPreViewTopButton () {
      return this.item.prevwContExpsrYn === 'Y' && this.item.dvlTyp !== 'P'
    },
    showDetailTopButton () {
      return this.item.dvlTyp === 'P' && this.item.prevwUrl !== null
    },
    showOpenOrApplyButtons () {
      return ['CF', 'CM'].includes(this.item.prdtTyp)
    },
    showImmediateLearnOrApplyButtons () {
      return ['CE', 'KK'].includes(this.item.prdtTyp)
    },
    // 수강신청, 오픈예정
    getOpenOrApplyButtonConfig (item) {
      if (!item) return

      if (item.waitingYn === 'Y' && item.lrnrAplBtnExpsrYn !== 'N') {
        if (item.corsDgrCd === null || item.corsDgrCd === '') {
          if (item.ccclsYn === 'Y' || item.duseYn === 'Y' ) {
            return {
              id: '',
              label: '미운영',
              isDisabled: true
            }
          } else {
            return {
              id: '',
              label: '오픈예정',
              isDisabled: true
            }
          }
        }

        if (item.aplPsbYn === 'N') {
          return {
            id: '',
            label: '수강신청',
            isDisabled: true,
            tooltip: '수강신청 기간이 아닙니다.'
          }
        }

        return {
          id: 'btnNextTop',
          label: '수강신청',
          isDisabled: false
        }
      }
      if (item.waitingYn === 'N' && item.lrnrAplBtnExpsrYn !== 'N') {
        if (item.corsDgrCd === null || item.corsDgrCd === '') {
          if (item.ccclsYn === 'Y' || item.duseYn === 'Y' ) {
            return {
              id: '',
              label: '미운영',
              isDisabled: true
            }
          } else {
            return {
              id: '',
              label: '오픈예정',
              isDisabled: true
            }
          }
        }

        if (item.aplPsbYn === 'N') {
          return {
            id: '',
            label: '수강신청',
            isDisabled: true,
            tooltip: '수강신청 기간이 아닙니다.'
          }
        }

        return {
          id: 'btnNextTop',
          label: '수강신청',
          isDisabled: false
        }
      }
      return {
        id: '',
        label: '',
        isDisabled: false
      }
    },

    // 학습하기, 수강신청
    getImmediateLearnOrApplyButtonConfig (item) {
      if (!item) return

      if (item.imdtlLrnYn === 'Y') {
        if (this.btnCtrl === 'LEARN') {
          return {
            id: 'btnLearnTop',
            label: '학습하기',
            isDisabled: false
          }
        }

        if (this.btnCtrl === 'APL' && item.lrnrAplBtnExpsrYn !== 'N') {
          return {
            id: 'btnImdtlLrnTop',
            label: item.aplBtnExpsrCdNm,
            isDisabled: false
          }
        }

        if (item.lrnrAplBtnExpsrYn !== 'N') {
          return {
            id: '',
            label: item.aplBtnExpsrCdNm,
            isDisabled: true,
            tooltip: '수강신청 기간이 아닙니다.'
          }
        }
      }

      /* if (this.btnCtrl === 'LIC') {
        return {
          id: 'btnLicTop',
          label: '라이센스 신청',
          isDisabled: false
        }
      } */

      if (this.btnCtrl === 'APL' && item.lrnrAplBtnExpsrYn !== 'N') {
        if (item.finYn === 'N') {
          return {
            id: '',
            label: '신청마감',
            isDisabled: true
          }
        }

        if (item.finYn === 'Y') {
          return {
            id: 'btnNextTop',
            label: '수강신청',
            isDisabled: false
          }
        }
      }

      if (this.btnCtrl === 'LEARN') {
        return {
          id: 'btnLearnTop',
          label: '학습하기',
          isDisabled: false
        }
      }

      if (this.btnCtrl === 'DISABLE' && item.lrnrAplBtnExpsrYn !== 'N') {
        if (item.corsDgrCd === null || item.corsDgrCd === '') {
          if (item.ccclsYn === 'Y' || item.duseYn === 'Y' ) {
            return {
              id: '',
              label: '미운영',
              isDisabled: true
            }
          } else {
            return {
              id: '',
              label: '오픈예정',
              isDisabled: true
            }
          }
        }

        return {
          id: '',
          label: '수강신청',
          isDisabled: true,
          tooltip: '수강신청 기간이 아닙니다.'
        }
      }

      return {
        id: '',
        label: '',
        isDisabled: false
      }
    },

    previewCourse (item) {
      console.log('홍보영상, 맛보기, 과정상세정보 클릭', item)
      const selectCorsCd = this.removeTags(item.corsCd)
      const selectProMovYn = item.proMovYn
      let lrnTypeCd = 'P'
      if (selectProMovYn === 'Y') {
        lrnTypeCd = 'H'
      }

      const windowOptions = {
        width: 1000,
        height: 800,
        scrollbars: 'no'
      }
      let prevwUrl = `https://learning.multicampus.com/lrn/common/commCrsPreview?lrnTypeCd=P&code=${selectCorsCd}` // 홍보영상

      if (lrnTypeCd === 'P' && item.prevwUrl) {
        prevwUrl = item.prevwUrl // 맛보기
      }

      if (item.dvlTyp === 'P' && item.prevwUrl) {
        prevwUrl = item.prevwUrl // 과정상세
      }

      prevwUrl && this.$utils.common.openWindowPopup(prevwUrl, {}, undefined, windowOptions, true)
    },
    async startLearning () {
      console.log('학습하기 로직')

      if (!window.vue.getStore('root').state.session.authenticated) {
        const authConfirm = await this.$popup.confirm(undefined, {title: '알림', contents: '로그인이 필요한 메뉴입니다. <br> 로그인하시겠습니까?', okBtnNm: '로그인'})
        if (authConfirm) {
          this.$goPage({name: 'Login'})
        }
        return
      }

      this.goOpenStudy(this.removeTags(this.item.corsYr), this.removeTags(this.item.corsCd), this.removeTags(this.item.corsDgrCd), this.removeTags(this.item.eduDgrCd))
    },
    /* immediateLearning () {
      console.log('즉시학습 로직')
    },
    applyForCourse () {
      console.log('수강신청 로직')
      if (!this.item) return
      this.$goPage({name: 'PaymentOrder'})
    }, */
    async order () { /* 수강신청하기 */
      if (!window.vue.getStore('root').state.session.authenticated) {
        const authConfirm = await this.$popup.confirm(undefined, {title: '알림', contents: '로그인이 필요한 메뉴입니다. <br> 로그인하시겠습니까?', okBtnNm: '로그인'})
        if (authConfirm) {
          this.$goPage({name: 'Login'})
        }
        return
      }

      if (isEmpty(this.item)) {
        return
      }

      if (this.item.aplYn === 'N' || this.promoInfo.activeYn === 'N') {
        this.$popup.toast('프로모션 기간이 아닙니다.')
        return
      }

      const params = {
        eduGrpCd: this.item.eduGrpCd || this.promoInfo.eduGroupCode,
        corsCd: this.item.corsCd,
        corsYr: this.item.corsYr,
        corsDgrCd: this.item.corsDgrCd,
        prchsTyp: 'payment',
        busnCd: this.promoInfo.busnCd,
        promoId: this.promoInfo.promoId,
        promoNm: this.promoInfo.promoNm
      }

      console.log('order params =====================>', params)

      try {
        let insertCartResult = await this.$http.busn.insertCart(this, params)

        if (insertCartResult.data.status === 'OK') {
          console.log('#insertCartResult::', insertCartResult.data.data)
          if (insertCartResult.data.data.corsYn !== undefined && insertCartResult.data.data.corsYn === 'Y') {
            await this.$popup.alert(this.$el, {title: '알림', contents: '과정(' + insertCartResult.data.data.corsNm + ')와 학습기간이 겹쳐서 신청이 불가능합니다.'})
            return
            // [TO_DO]TOTALSR-52790 CF05 정부지원사업 과정의 경우 겹치게 학습기간 겹치게 신청 안되도로 체크로직 넣기
          } else {
            window.vue.getStore('cartInfo').dispatch('updateCartCnt')
            if (this.item.speakCorsYn === 'Y') { // 스픽 과정
              let params = {
                cartPrdtNos: insertCartResult.data.data.cartPrdtNo,
                eduGrpCd: this.item.eduGrpCd || this.promoInfo.eduGroupCode,
                corsCd: this.item.corsCd,
                corsNm: this.item.corsNm,
                prdtTyp: this.item.prdtTyp,
                lrnPrd: this.item.lrnPrd,
                lrnPrdTypNm: this.item.lrnPrdTypNm,
                eduStartDtm: this.item.eduStartDtm,
                eduEndDtm: this.item.eduEndDtm
              }
              this.$goPage({name: 'PaymentSpeakCors', query: params})
            } else if (this.item.telYn === 'Y') { // 전화외국어 과정
              let params = {
                cartPrdtNos: insertCartResult.data.data.cartPrdtNo,
                eduGrpCd: this.item.eduGrpCd || this.promoInfo.eduGroupCode,
                corsCd: this.item.corsCd,
                corsNm: this.item.corsNm,
                prdtTyp: this.item.prdtTyp,
                lrnPrd: this.item.lrnPrd,
                lrnPrdTypNm: this.item.lrnPrdTypNm,
                eduStartDtm: this.item.eduStartDtm,
                eduEndDtm: this.item.eduEndDtm
              }
              this.$goPage({name: 'PaymentTelCors', query: params})
            } else {
              if (this.item.prdtTyp !== 'CE' && (this.item.stlTyp === 'B2BC' || this.item.refndYn === 'Y' /* || evtYn */) && this.item.futrStdyUseYn !== 'Y') {
                let paramsApl = {
                  cartPrdtNos: insertCartResult.data.data.cartPrdtNo,
                  eduGrpCd: this.item.eduGrpCd || this.promoInfo.eduGroupCode,
                  corsCd: this.item.corsCd,
                  corsNm: this.item.corsNm
                }
                // 신규 신청정보로 이동(회사지원 선택화면)
                this.$goPage({name: 'PaymentAplInfo', query: paramsApl})
              } else {
                // 신청하기 및 기존 결재로 이동
                this.$goPage({name: 'PaymentOrder', query: { cartPrdtNos: insertCartResult.data.data.cartPrdtNo }})
              }
            }
            return
          }
        }

        await this.$popup.alert(this.$el, { title: '알림', contents: insertCartResult.data.message })
      } catch (error) {
        console.log(error)
        await this.$popup.alert(this.$el, {title: '알림', contents: '서비스 장애가 발생하였습니다.'})
      }
    },

    removeTags (input) {
      if (input) {
        input = input.replaceAll(/<\/?b>/g, '')
      }
      return input
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/common/ComCorsButtonGroup.vue